<div class="container-sm px-alt-3 main-container">
    <div class="container-sm px-alt-3">

        <div class="text-center">
            <h2 style="margin-bottom: 0">{{ 'employees.listTitle' | translate }}</h2>
        </div>

        <div class="search-component py-2">
            <div class="search-container">
                <input class="ihost-control" [(ngModel)]="search" name="search" type="search"
                    placeholder="{{ 'employees.placeholders.search' | translate }}">
                <button (click)="clearSearch()" class="btn-clear" type="button">&times;</button>
            </div>
            <a class="btn btn-sm btn-main px-2 ms-2" (click)="showAddModal()">
                {{ 'common.buttons.addNew' | translate }}
            </a>
        </div>
    </div>

    <div class="container-sm mt-3 pb-5">
        <table class="list-table-item">
            <tbody *ngFor="let item of data | searchPipe:search:['name', 'mail', 'surname', 'username']">
                <tr>
                    <td>
                        <div style="display: flex; flex-direction: column; gap: 2px;">                            
                            <b class="text-normal">{{item.username}}</b>
                            <span class="text-sm text-faded">{{item.surname}} {{item.name}}</span>
                        </div>
                    </td>
                    <td class="td-actions w-1p text-nowrap">
                        <app-dotted-dropdown [context]="item" [actions]="actions"></app-dotted-dropdown>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>

<app-modal-dialog #modalPassword title="{{ 'employees.changePassword' | translate }}" modalId="empl-mod-pass-dialog"
    okText="{{ 'common.save' | translate }}" [isValid]="arePasswordDetailsValid" [customClose]="true"
    (onClose)="modalPasswordClosed($event)">
    <div class="form-col">
        <label class="mb-2 text-uppercase">{{ 'employees.placeholders.password' | translate }}</label>        
        <input [(ngModel)]="selected.password" type="text" class="ihost-control w-100 mb-2"
            [ngModelOptions]="{standalone: true}" [autocomplete]="'off'" />
    </div>

    <div>
        <span style="color: red; margin-top: 6px; display: block;">{{validationErrorMessage}}</span>
    </div>
</app-modal-dialog>

<app-modal-dialog #modal title="{{ (selected.id == '' ? 'common.buttons.addNew' : 'common.buttons.edit') | translate }}"
    modalId="empl-mod-dialog" okText="{{ 'common.save' | translate }}" [isValid]="areDetailsValid" [customClose]="true"
    (onClose)="modalClosed($event)" [extraButtons]="modalExtraButtons">

    <form autocomplete="off">
        <div class="form-col" >
            <label class="mb-2 text-uppercase">{{ 'employees.placeholders.username' | translate }}</label>        
            <input *ngIf="selected.id == ''" [(ngModel)]="selected.username" type="text" class="ihost-control w-100 mb-2" [autocomplete]="'off'"
                [ngModelOptions]="{standalone: true}" />
            <p *ngIf="selected.id != ''">{{selected.username}}</p>
        </div>        
        <div class="form-col" *ngIf="selected.id == ''">
            <label class="mb-2 text-uppercase">{{ 'employees.placeholders.password' | translate }}</label>        
            <input [(ngModel)]="selected.password" type="text" class="ihost-control w-100 mb-2"
                [ngModelOptions]="{standalone: true}" [autocomplete]="'off'" />
        </div>

        <div class="form-col">
            <label class="mb-2 text-uppercase">{{ 'employees.placeholders.name' | translate }}</label>          
            <input [(ngModel)]="selected.name" required type="text" class="ihost-control w-100 mb-2"
                [ngModelOptions]="{standalone: true}" />
        </div>
        <div class="form-col">
            <label class="mb-2 text-uppercase">{{ 'employees.placeholders.surname' | translate }}</label>            
            <input [(ngModel)]="selected.surname" required type="text" class="ihost-control w-100 mb-2"
                [ngModelOptions]="{standalone: true}" />
        </div>
        <!-- <div class="form-col">
            <input [(ngModel)]="selected.mail" required type="text" class="ihost-control w-100 mb-2"
                [ngModelOptions]="{standalone: true}" placeholder="{{ 'employees.placeholders.email' | translate }}" />
        </div>
        <div class="form-col">
            <input [(ngModel)]="selected.phone" required type="text" class="ihost-control w-100 mb-2"
                [ngModelOptions]="{standalone: true}" placeholder="{{ 'employees.placeholders.phone' | translate }}" />
        </div> -->
        <div class="form-col">
            <label class="mb-2 text-uppercase">{{ 'employees.placeholders.type' | translate }}</label>            
            <app-dropdown [(model)]="selected.type" [items]="employeeTypes" [displayProperty]="'display'"
                [ngModelOptions]="{standalone: true}" [valueProperty]="'value'">
            </app-dropdown>
        </div>
    </form>

    <div>
        <span style="color: red; margin-top: 6px; display: block;">{{validationErrorMessage}}</span>
    </div>
</app-modal-dialog>

<app-modal-dialog #deleteModal title=" {{ 'employees.delete' | translate }}" modalId="delete-employee-modal"
    okText="{{ 'common.buttons.delete' | translate }}" (onClose)="deleteModalClosed($event)">
    <p>{{ 'common.info.delete' | translate }}</p>
</app-modal-dialog>